export default __webpack_public_path__ + "static/media/logo_footer.59550239.svg";